module.exports = __webpack_public_path__ + "static/media/color.3d826b58.png";